import { Component, Input, OnInit } from '@angular/core';
import { BagPassangerInt } from '@app/interfaces';

/**
 * Componente para mostrar el resumen de pago de equipaje.
 *
 */
@Component({
    selector: 'am-bags-payment',
    templateUrl: './am-bags-payment.component.html',
    styleUrls: ['./am-bags-payment.component.scss'],
    standalone: false
})
export class AmBagsPaymentComponent implements OnInit {

  /**
   * Lista de bolsas de 20kg asociadas a los pasajeros.
   * 
   * @type {BagPassangerInt[]}
   * @default []
   */
  @Input() bags20kg: BagPassangerInt[] = [];

  /**
   * Lista de bolsas de 25kg asociadas a los pasajeros.
   * 
   * @type {BagPassangerInt[]}
   * @default []
   */
  @Input() bags25kg: BagPassangerInt[] = [];

  /**
   * Lista de bolsas de 32kg asociadas a los pasajeros.
   * 
   * @type {BagPassangerInt[]}
   * @default []
   */
  @Input() bags32kg: BagPassangerInt[] = [];

  /**
   * Lista generada dinámicamente para almacenar el resumen de bolsas seleccionadas para el pago.
   * Contiene objetos con la cantidad de bolsas y su etiqueta correspondiente.
   * 
   * @type {Array<{ count: number, label: string }>}
   */
  listBagsPayments: any[];

  constructor() { }

  ngOnInit(): void {
    this.init();
  }


  init(){
    this.listBagsPayments = [];

    if(this.bags20kg?.length > 0){
      this.listBagsPayments.push({count: this.bags20kg?.length, label: 'bagsSelection.bags-payment.bags20Kg'});
    }
    if(this.bags25kg?.length > 0){
      this.listBagsPayments.push({count: this.bags25kg?.length, label: 'bagsSelection.bags-payment.bags25Kg'});
    }
    if(this.bags32kg?.length > 0){
      this.listBagsPayments.push({count: this.bags32kg?.length, label: 'bagsSelection.bags-payment.bags32Kg'});
    }
  }
}
